/*
 * Opens the cart drawer when a visitor arrives through a Shopify discount link
 * (/discount/<CODE>, optionally with ?redirect=/some/page).
 * ------------------------------------------------------------------
 * WHY NOT CHECK THE URL: /discount/<CODE> never renders the theme. Shopify
 * answers it with a 302 to the home page (or to ?redirect=...) and sets the
 * cookie `discount_code=<CODE>` (not HttpOnly, no expiry = session cookie) —
 * confirmed on muranojoias.com.br 2026-09-25. The page that actually loads no
 * longer has /discount/ in its URL, so that cookie is the signal.
 *
 * HOW AN ARRIVAL IS DETECTED — the cookie is present AND any of:
 * 1. It changed since the previous page of this site (last value kept in
 *    localStorage). The usual case: link opened from Instagram, e-mail,
 *    WhatsApp or in a new tab. Changes made while ON the site (coupon applied
 *    in the drawer, the background /discount/ fetch in
 *    bogos-aniversario-gift.js) are recorded on pagehide/visibilitychange so
 *    they don't count as an arrival on the next page.
 * 2. A /discount/ link on this site was just clicked (short-lived flag). The
 *    302 sets the cookie before the current page's pagehide runs, so (1)
 *    alone would see it as already recorded.
 * 3. This page load came through a same-origin redirect (the /discount/ 302)
 *    and not from another page of this site: the link pasted in the address
 *    bar of a tab already on the store (same pagehide race as 2), or the same
 *    code followed again (cookie value unchanged).
 * Following the same code again through a redirect chain that crosses origins
 * (e.g. e-mail click tracking) doesn't reopen: browsers report 0 redirects
 * then and the cookie doesn't change. The first time always opens.
 *
 * ES5 on purpose: discount links are mostly opened inside Instagram/Facebook
 * WebViews (same reasoning as the inline scripts in theme.liquid).
 */
(function () {
  if (window.__discountLinkCartOpenInstalled) return;
  window.__discountLinkCartOpenInstalled = true;

  if (window.Shopify && window.Shopify.designMode) return;

  var SEEN_KEY = "muranoDiscountCookieSeen";
  var CLICKED_KEY = "muranoDiscountLinkClickedAt";
  var CLICKED_MAX_AGE_MS = 2 * 60 * 1000;
  // Let the landing page paint first so the drawer visibly slides in over it.
  var OPEN_DELAY_MS = 600;

  // Without storage there's no way to open "only once", and opening on every
  // page would be worse than not opening at all.
  var storage;
  try {
    storage = window.localStorage;
    storage.setItem("__dlco", "1");
    storage.removeItem("__dlco");
  } catch (e) {
    return;
  }

  function read(key) {
    try { return storage.getItem(key); } catch (e) { return null; }
  }
  function write(key, value) {
    try { storage.setItem(key, value); } catch (e) {}
  }
  function remove(key) {
    try { storage.removeItem(key); } catch (e) {}
  }

  function discountCookie() {
    var match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!match) return "";
    try { return decodeURIComponent(match[1]); } catch (e) { return match[1]; }
  }

  function rememberCookie() {
    write(SEEN_KEY, discountCookie());
  }

  function wasRedirected() {
    try {
      var perf = window.performance;
      var entries = perf && perf.getEntriesByType ? perf.getEntriesByType("navigation") : null;
      if (entries && entries.length) return entries[0].redirectCount > 0;
      return !!(perf && perf.navigation && perf.navigation.redirectCount > 0);
    } catch (e) {
      return false;
    }
  }

  function cameFromThisSite() {
    var origin = window.location.protocol + "//" + window.location.host;
    var referrer = document.referrer || "";
    return referrer === origin || referrer.indexOf(origin + "/") === 0;
  }

  var code = discountCookie();
  var clickedAt = parseInt(read(CLICKED_KEY), 10) || 0;
  var clickedLink = clickedAt > 0 && Date.now() - clickedAt < CLICKED_MAX_AGE_MS;
  var arrived =
    code !== "" &&
    (code !== read(SEEN_KEY) || clickedLink || (wasRedirected() && !cameFromThisSite()));
  remove(CLICKED_KEY);
  rememberCookie();

  window.addEventListener("pagehide", rememberCookie);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") rememberCookie();
  });

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      var link = target && typeof target.closest === "function" ? target.closest('a[href*="/discount/"]') : null;
      if (link) write(CLICKED_KEY, String(Date.now()));
    },
    true
  );

  if (!arrived) return;

  function openDrawer() {
    // Not rendered on /cart or when the theme uses the cart page instead of the drawer.
    var drawer = document.querySelector("m-cart-drawer");
    if (!drawer || !window.customElements) return;
    // assets/cart.js (loaded by snippets/cart-drawer.liquid) defines the element.
    window.customElements.whenDefined("m-cart-drawer").then(function () {
      setTimeout(function () {
        if (drawer.classList.contains("m-cart-drawer--active")) return;
        drawer.open();
      }, OPEN_DELAY_MS);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", openDrawer);
  } else {
    openDrawer();
  }
})();
